import { IMAGE_CDN_URL } from './imageCDN';

const LOGO_IMAGE_SIZE = {
    XXS_SMALL: 'xxSmall',
    XS_SMALL: 'xSmall',
    SMALL: 'small',
    SMALL_MEDIUM: 'small-medium',
    MEDIUM: 'medium',
    LARGE: 'large',
};

const CLOUDINARY_SIZE_TRANSFORM = {
    LOGO: {
        [LOGO_IMAGE_SIZE.XXS_SMALL]: 'c_scale,f_webp,q_auto,w_32',
        [LOGO_IMAGE_SIZE.XS_SMALL]: 'c_scale,f_webp,q_auto,w_60',
        [LOGO_IMAGE_SIZE.SMALL]: 'c_scale,f_webp,q_auto,w_70',
        [LOGO_IMAGE_SIZE.SMALL_MEDIUM]: 'c_scale,f_webp,q_auto,w_80',
        [LOGO_IMAGE_SIZE.MEDIUM]: 'c_scale,f_webp,q_auto,w_120',
        [LOGO_IMAGE_SIZE.LARGE]: 'c_scale,f_webp,q_auto,w_180',
    },
};

const DIGIT_REGEX = /\/?v[0-9]*\//;

export const getCloudinaryImagePathById = (
    cloudinaryId,
    size = LOGO_IMAGE_SIZE.SMALL,
    injectedTransforms = CLOUDINARY_SIZE_TRANSFORM.LOGO
) => {
    const formattedUrl = `/v1${cloudinaryId.replace(DIGIT_REGEX, '/')}`;
    return `${IMAGE_CDN_URL}/${injectedTransforms[size]}${formattedUrl}`;
};

export const buildImagePath = (cloudinaryId, size, injectedTransforms) => {
    const src = `${IMAGE_CDN_URL}/`;
    const regex = /\/?v[0-9]+\//;
    const defaultTransforms = {
        button: 'c_scale,f_webp,q_auto,h_22',
        xxSmall: 'c_scale,f_webp,q_auto,h_24',
        xSmall: 'c_scale,f_webp,q_auto,w_60',
        small: 'c_scale,f_webp,q_auto,w_70',
        default: 'c_scale,f_webp,q_auto,h_300',
        fullScreen: 'c_scale,f_webp,q_auto,w_1500',
        xLarge: 'c_scale,g_center,r_max,w_90,h_90,z_0.6',
        xxLarge: 'c_scale,g_center,r_max,w_106,h_106,z_0.6',
        size150: 'c_scale,g_center,r_max,w_150,h_100,z_0.6',
        'small-lPad': 'c_lpad,f_webp,q_auto,w_60,h_60',
    };

    const formattedUrl = cloudinaryId.startsWith('/')
        ? `/v1${cloudinaryId.replace(regex, '/').replace('.anim', '')}`
        : `/v1/${cloudinaryId.replace(regex, '/').replace('.anim', '')}`;
    const transforms = injectedTransforms || defaultTransforms;
    return src + transforms[size] + formattedUrl;
};

const logoTransforms = { default: 'c_lpad,f_auto,q_auto,w_75,h_75' };

export const buildCompanyLogoSrc = (cloudinaryId) => buildImagePath(
    cloudinaryId || '/v1/icons/company_2x.png',
    'default',
    logoTransforms
);
